export const MEMO_SEARCH_MODAL_END_POINT = {
  SEARCH: 'api/v1/memo/search',
  RECENT_VIEWED: 'api/v1/memo/recent-viewed',
} as const;
